module.exports = "<div ncy-breadcrumb></div> <h1>{{::vm.seller.name}} <translate>products</translate></h1> <seller-total-price-discounts discounts=vm.productOverviewModel.totalPriceDiscounts></seller-total-price-discounts> <product-overview on-filter-change=vm.onFilterChange() context=seller-products-overview model=vm.productOverviewModel parent-state=vm.parentState></product-overview>";


//////////////////
// WEBPACK FOOTER
// ./features/seller/products.html
// module id = 677
// module chunks = 0